'use client';

import { bunja } from 'bunja';
import { NamespaceKeys, NestedKeyOf, createTranslator } from 'use-intl';

import { LocaleScope, MessagesScope } from './provider';

export { FormattedMessage, T, type MessageKey } from './formatted-message';
export * from './provider';

export const i18nBunja = bunja(() => {
  const locale = bunja.use(LocaleScope);
  const messages = bunja.use(MessagesScope);
  function getT<NestedKey extends NamespaceKeys<IntlMessages, NestedKeyOf<IntlMessages>> = never>(
    namespace?: NestedKey,
  ) {
    // next-intl 패키지의 내부 타입 문제로 타입 검사가 통과하지 않습니다.
    // 참고: https://github.com/amannn/next-intl/blob/v3.26.4/packages/use-intl/src/core/createTranslator.tsx
    // ts 언어서버에서는 타입 오류가 발생하지 않는데 tsc로 전체 검사할 때 오류가 발생하기 때문에
    // ts-expect-error 대신 ts-ignore를 사용합니다.
    // @ts-ignore
    return createTranslator<NestedKey>({ locale, messages, namespace });
  }
  return { getT };
});
i18nBunja.debugLabel = 'i18nBunja';
